
<section>

 <div id="editorstory-container" ref="editor"></div>  
     <input type="file" ref="image" class="d-none" @change="fnOnChangeButtonImage" hidden/>
     <input type="hidden" v-model="content" name="content">
     <input type="hidden" v-model="imgjson" name="imgjson">
</section>
